import { useTranslation } from 'react-i18next';
import { LayoutGrid, List } from 'lucide-react';
import { cn } from '../../lib/utils';

export type ViewMode = 'grid' | 'list';

interface ViewModeToggleProps {
    value: ViewMode;
    onChange: (mode: ViewMode) => void;
}

interface SegmentProps {
    mode: ViewMode;
    active: boolean;
    label: string;
    onSelect: (mode: ViewMode) => void;
    children: React.ReactNode;
}

const Segment = ({ mode, active, label, onSelect, children }: SegmentProps) => (
    <button
        type="button"
        onClick={() => onSelect(mode)}
        aria-label={label}
        aria-pressed={active}
        className={cn(
            'inline-flex h-7 w-8 items-center justify-center rounded-md transition-colors',
            active
                ? 'bg-accent text-accent-foreground'
                : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
        )}
    >
        {children}
    </button>
);

export const ViewModeToggle = ({ value, onChange }: ViewModeToggleProps) => {
    const { t } = useTranslation();
    return (
        <div className="inline-flex items-center gap-1 rounded-lg border border-input bg-background p-0.5">
            <Segment
                mode="grid"
                active={value === 'grid'}
                label={t('folders.overview.viewMode.grid')}
                onSelect={onChange}
            >
                <LayoutGrid className="h-3.5 w-3.5" aria-hidden="true" />
            </Segment>
            <Segment
                mode="list"
                active={value === 'list'}
                label={t('folders.overview.viewMode.list')}
                onSelect={onChange}
            >
                <List className="h-3.5 w-3.5" aria-hidden="true" />
            </Segment>
        </div>
    );
};
